<script>
  // Standard scaffold for create/edit form pages: a centered, width-capped column of
  // Cards, with a sticky-feeling action footer. Pair with FormSection for grouping.
  //
  //   <FormLayout onsubmit={submit}>
  //     <FormSection title="Details">…fields…</FormSection>
  //     {#snippet footer()}
  //       <Button variant="ghost" href="/quests">Cancel</Button>
  //       <SubmitButton processing={$form.processing} label="Save" />
  //     {/snippet}
  //   </FormLayout>
  let { onsubmit = null, width = 'lg', children, footer } = $props()

  const WIDTHS = { sm: 'max-w-md', md: 'max-w-xl', lg: 'max-w-2xl', xl: 'max-w-4xl' }
</script>

<form novalidate {onsubmit} class="mx-auto w-full {WIDTHS[width] ?? WIDTHS.lg} space-y-6">
  {@render children()}
  {#if footer}
    <div class="flex items-center justify-end gap-2 pt-2">{@render footer()}</div>
  {/if}
</form>
